module.exports = __webpack_public_path__ + "img/3076328-74-7.3950d812.png";